import { Grid } from '@mui/joy'
import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { CarBrand } from '~/shared/api/carBrand'
import { CarModel } from '~/shared/api/carModel'
import { Region } from '~/shared/api/regions'
import {
  categoryAutoOptions,
  fuelTypeOptions,
  transmissionOptions,
} from '~/shared/config/constants'
import { YEAR_MASK } from '~/shared/config/masks'
import {
  ArrayInput,
  AsyncAutocompleteInput,
  AutocompleteInput,
  yearValidator,
  yearTransformer,
} from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type CarFiltersProps = {
  disabled?: boolean
  skeletonShow?: boolean
  isPromotion?: boolean
}

export function CarFilters({ disabled, skeletonShow }: CarFiltersProps) {
  const { watch } = useFormContext()

  const brands = watch('carBrandsIds')

  const brandIds = useMemo(() => {
    if (!Array.isArray(brands) || brands.length === 0) return undefined
    return brands.map((b) => b.id)
  }, [brands])

  return (
    <Container>
      <ContainerTitle>
        Фильтры по автомобилям (только для Промо-кодов)
      </ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid container xs={12}>
          <Grid xs={6}>
            <AsyncAutocompleteInput
              name='carRegionsIds'
              label='Регионы автомобилей'
              fetchOptions={Region.fetchOptions}
              readOnly={disabled}
              multiple
              autocompleteXs={12}
              skeletonShow={skeletonShow}
              placeholder='Выберите регион автомобиля'
            />
          </Grid>
          <Grid xs={6}>
            <AsyncAutocompleteInput
              name='carBrandsIds'
              label='Марка автомобилей'
              fetchOptions={CarBrand.fetchOptions}
              readOnly={disabled}
              multiple
              autocompleteXs={12}
              skeletonShow={skeletonShow}
              placeholder='Выберите марку автомобиля'
            />
          </Grid>
          <Grid xs={6}>
            <AsyncAutocompleteInput
              name='carModelsIds'
              label='Модели автомобилей'
              // eslint-disable-next-line
              fetchOptions={(search) => CarModel.fetchOptions(search, brandIds)}
              readOnly={disabled}
              multiple
              autocompleteXs={12}
              skeletonShow={skeletonShow}
              placeholder='Выберите модель автомобиля'
              queryKey={brandIds ? [brandIds] : []}
            />
          </Grid>
          <Grid xs={6}>
            <AutocompleteInput
              name='carCategories'
              label='Категории автомобилей'
              options={categoryAutoOptions}
              multiple
              readOnly={disabled}
              autocompleteXs={12}
              placeholder='Выберите категорию автомобиля'
            />
          </Grid>
          <Grid xs={6}>
            <AutocompleteInput
              name='carTypesTransmission'
              label='Типы трансмиссий'
              options={transmissionOptions}
              multiple
              readOnly={disabled}
              autocompleteXs={12}
              placeholder='Выберите тип трансмиссии'
            />
          </Grid>
          <Grid xs={6}>
            <ArrayInput
              name='carYearsOfManufacture'
              label='Годы выпуска автомобилей'
              placeholder='Введите год (например, 2020) и нажмите Enter'
              readOnly={disabled}
              skeletonShow={skeletonShow}
              autocompleteXs={12}
              validate={yearValidator}
              transformValue={yearTransformer}
              noOptionsText='Введите год и нажмите Enter'
              mask={YEAR_MASK}
              definitions={{ '0': /[0-9]/ }}
            />
          </Grid>
        </Grid>
        <Grid container xs={12}>
          <Grid xs={6}>
            <AutocompleteInput
              name='carTypesFuel'
              label='Типы топлива'
              options={fuelTypeOptions}
              multiple
              readOnly={disabled}
              autocompleteXs={12}
              placeholder='Выберите тип топлива'
            />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}
